// extracted by mini-css-extract-plugin
export var imageBox = "homeImage-module--image-box--f8819";
export var textOverlay = "homeImage-module--text-overlay--ab1ca";